// src/services/notificationService.js
import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";

export const notificationService = {
  getAll: async (params = {}) => {
    const res = await apiClient.get(ENDPOINTS.NOTIFICATION.GET_ALL, {
      params,
    });
    return res;
  },

  updateStatus: async (id, data) => {
    // same idea as Angular's updateStatus
    return apiClient.put(ENDPOINTS.NOTIFICATION.UPDATE(id), data);
  },
};

export default notificationService;
